import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import "./Dashboard.css";
import logo from "../assets/logo.png";
import chip from "../assets/silver_qr.png";
import sendarrow from "../assets/send.png";
import receivearrow from "../assets/recieve-arrow.png";
import buyarrow from "../assets/buy.png";
import historyarrow from "../assets/history.png";
import Card from "../assets/cards-dashboard/Card";
import { getCryptoIcon } from "../config/cryptoIcons";
import spinWheelIcon from "../assets/spinandwin.png"; // Add this import

// Static fallback data
const STATIC_ASSETS = [
  {
    name: "BTC",
    symbol: "btc",
    sub: "Bitcoin",
    price: 85966.43,
    balance: 0.0665,
    change: -0.17,
    balanceValue: 5713.45
  },
  {
    name: "USDT",
    symbol: "usdtBnb",
    sub: "Tether BEP-20",
    price: 1.0,
    balance: 8766.42,
    change: 0.0,
    balanceValue: 8766.42
  }
];

const getDisplayName = (symbol = "") => {
  const s = symbol.toLowerCase();
  if (s.startsWith("usdt")) return "USDT";
  return s.toUpperCase();
};

const mapCardType = (cardType = "") => {
  const t = cardType.toLowerCase();
  if (t.includes("merchant")) return "merchant";
  if (t.includes("classic")) return "classic";
  if (t.includes("prime")) return "prime";
  if (t.includes("platinum")) return "platinum";
  if (t.includes("elite")) return "elite";
  return "classic";
};

const ADMIN_EMAIL = "bitabox860@gmail.com";

// WhatsApp Float Component
const WhatsAppFloat = ({ 
  phoneNumber = "15485825756", 
  message = "Hello! I need assistance with my InstaCoinXPay dashboard.",
  position = "right",
  bottom = "30px",
  right = "30px",
  left = "auto",
  size = "54px",
  iconSize = "28px",
  pulseEffect = true,
  className = "",
  style = {}
}) => {
  const formattedNumber = phoneNumber.replace(/[^\d]/g, '');
  const whatsappUrl = `https://wa.me/${formattedNumber}?text=${encodeURIComponent(message)}`;
  
  const positionStyles = position === "left" 
    ? { left: left || "20px", right: "auto" }
    : { right: right || "20px", left: "auto" };

  const combinedStyles = {
    position: 'fixed',
    bottom: bottom,
    width: size,
    height: size,
    borderRadius: '50%',
    backgroundColor: '#25d366',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
    zIndex: 10000,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    textDecoration: 'none',
    ...positionStyles,
    ...style
  };

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer nofollow"
      className={`whatsapp-float ${pulseEffect ? 'pulse' : ''} ${className}`}
      style={combinedStyles}
      aria-label="Chat on WhatsApp"
      title="Chat on WhatsApp"
    >
      <svg 
        width={iconSize} 
        height={iconSize} 
        viewBox="0 0 24 24"
        fill="white"
      >
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.074-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.074-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.76.982.998-3.677-.236-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.826 9.826 0 012.9 6.994c-.004 5.45-4.438 9.88-9.888 9.88m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.333.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.333 11.893-11.893 0-3.18-1.24-6.162-3.495-8.411" />
      </svg>
    </a>
  );
};

/* ================= SPIN WHEEL NAVIGATION BUTTON (Navigates to SpinWheel) ================= */
const SpinWheelNavButton = ({ 
  position = "right",
  bottom = "100px", // Positioned above WhatsApp button
  right = "30px",
  left = "auto",
  size = "100px",
  pulseEffect = true,
  className = "",
  style = {}
}) => {
  const navigate = useNavigate();
  
  const positionStyles = position === "left" 
    ? { left: left || "20px", right: "auto" }
    : { right: right || "20px", left: "auto" };

  const combinedStyles = {
    position: 'fixed',
    bottom: bottom,
    width: size,
    height: size,
    borderRadius: '50%',
    background: 'radial-gradient(circle at 30% 30%, #f7931a, #c8930a)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 8px 25px rgba(247, 147, 26, 0.5), 0 0 20px rgba(200, 147, 10, 0.4)',
    zIndex: 10000,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    textDecoration: 'none',
    border: '3px solid rgba(255, 215, 0, 0.6)',
    overflow: 'hidden',
    padding: '0px',
    ...positionStyles,
    ...style
  };

  // Add keyframes for pulse animation if not already defined
  React.useEffect(() => {
    if (!document.querySelector('#spin-wheel-nav-keyframes-dashboard')) {
      const styleSheet = document.createElement("style");
      styleSheet.id = 'spin-wheel-nav-keyframes-dashboard';
      styleSheet.textContent = `
        @keyframes spinWheelNavPulse {
          0% {
            box-shadow: 0 8px 25px rgba(247, 147, 26, 0.5), 0 0 20px rgba(200, 147, 10, 0.4), 0 0 0 0 rgba(247, 147, 26, 0.7);
          }
          70% {
            box-shadow: 0 8px 35px rgba(247, 147, 26, 0.7), 0 0 30px rgba(200, 147, 10, 0.6), 0 0 0 15px rgba(247, 147, 26, 0);
          }
          100% {
            box-shadow: 0 8px 25px rgba(247, 147, 26, 0.5), 0 0 20px rgba(200, 147, 10, 0.4), 0 0 0 0 rgba(247, 147, 26, 0);
          }
        }
        
        @keyframes spinWheelNavGlow {
          0% {
            filter: drop-shadow(0 0 5px #f7931a);
          }
          50% {
            filter: drop-shadow(0 0 15px #c8930a);
          }
          100% {
            filter: drop-shadow(0 0 5px #f7931a);
          }
        }
        
        @keyframes spinWheelNavRotate {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
        
        .spin-wheel-nav-float {
          animation: ${pulseEffect ? 'spinWheelNavPulse 2s infinite, spinWheelNavGlow 3s infinite' : 'none'};
        }
        
        .spin-wheel-nav-float:hover {
          transform: scale(1.15) rotate(10deg) !important;
          background: radial-gradient(circle at 30% 30%, #ffd700, #f7931a) !important;
          box-shadow: 0 10px 40px rgba(247, 147, 26, 0.8), 0 0 35px rgba(255, 215, 0, 0.7) !important;
        }
        
        .spin-wheel-nav-float:hover .wheel-icon-image {
          transform: scale(1.2) rotate(15deg) !important;
        }
        
        .wheel-icon-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
          transition: transform 0.3s ease;
        }
      `;
      document.head.appendChild(styleSheet);
    }
  }, [pulseEffect]);

  const handleClick = () => {
    navigate('/spinwheel');
  };

  return (
    <button
      onClick={handleClick}
      className={`spin-wheel-nav-float ${className}`}
      style={combinedStyles}
      aria-label="Go to Fortune Wheel"
      title="Spin the Fortune Wheel!"
    >
      <img 
        src={spinWheelIcon} 
        alt="Fortune Wheel"
        className="wheel-icon-image"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          borderRadius: '50%',
          transition: 'transform 0.3s ease',
          transform: 'scale(1.1)'
        }}
      />
      
      <div style={{
        position: 'absolute',
        inset: '-6px',
        borderRadius: '50%',
        border: '3px solid rgba(255, 215, 0, 0.5)',
        borderTopColor: '#f7931a',
        borderRightColor: '#ffd700',
        borderBottomColor: '#f7931a',
        borderLeftColor: '#ffd700',
        opacity: 0.9,
        animation: 'spinWheelNavRotate 4s linear infinite',
        pointerEvents: 'none',
        boxShadow: '0 0 15px rgba(247, 147, 26, 0.6)'
      }} />
      
      <div style={{
        position: 'absolute',
        inset: '2px',
        borderRadius: '50%',
        border: '1px solid rgba(255, 255, 255, 0.3)',
        opacity: 0.5,
        pointerEvents: 'none'
      }} />
    </button>
  );
};

const Dashboard = () => {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [dashboardData, setDashboardData] = useState(null);
  const [tickerData, setTickerData] = useState([]);
  
  const [portfolioSummary, setPortfolioSummary] = useState(null);
  const [walletBalance, setWalletBalance] = useState(null);
  const [loading, setLoading] = useState({
    dashboard: false,
    ticker: false,
    portfolio: false,
    balance: false,
  });
  const [userProfile, setUserProfile] = useState(null);
  const [userEmail, setUserEmail] = useState(localStorage.getItem("userEmail"));
  const [totalBalance, setTotalBalance] = useState("$0");
  const [userAssets, setUserAssets] = useState([]);
  const [dataSource, setDataSource] = useState("live");
  const [lastUpdate, setLastUpdate] = useState("");
  
  // ✅ FIX: Initialize cardData from localStorage to preserve after transactions
  const [cardData, setCardData] = useState(() => {
    const savedCard = localStorage.getItem("userCardData");
    return savedCard ? JSON.parse(savedCard) : null;
  });

  const isAdmin = userEmail === ADMIN_EMAIL;

  /* ================= FETCH DEBIT CARD ================= */
  const fetchDebitCard = async () => {
    try {
      if (!userEmail) return;

      console.log("💳 Fetching debit card for email:", userEmail);
      
      const res = await axios.get(
        `https://backend-srtt.onrender.com/api/debit-card/by-email/${userEmail}`,
        { withCredentials: true }
      );

      // ✅ Save to both state and localStorage to persist across transactions
      if (res.data.success && res.data.data) {
        console.log("💳 Card data received:", res.data.data);
        setCardData(res.data.data);
        localStorage.setItem("userCardData", JSON.stringify(res.data.data));
      }

    } catch (err) {
      // ✅ No debit card applied yet - don't clear existing data
      if (err.response?.status === 404) {
        console.log("💳 No card application found");
        // Only set to null if we don't have saved data
        if (!localStorage.getItem("userCardData")) {
          setCardData(null);
        }
      } else {
        console.error("Error fetching debit card:", err);
      }
    }
  };

  // Format currency
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  const fetchUserProfile = async () => {
    try {
      const token = localStorage.getItem("token");
      const userId = localStorage.getItem("userId");

      if (!token || !userId) return;

      const res = await axios.get(
        `https://backend-srtt.onrender.com/api/auth/users/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data.success) {
        setUserProfile(res.data.data);
        localStorage.setItem("userProfile", JSON.stringify(res.data.data));
      }
    } catch (error) {
      console.error("Error fetching user profile:", error.message);
    }
  };

  // Format percentage
  const formatPercentage = (value) => {
    const sign = value >= 0 ? "+" : "";
    return `${sign}${value.toFixed(2)}%`;
  };

  // ================= FETCH DASHBOARD DATA =================
  const fetchDashboardData = async () => {
    try {
      setLoading(prev => ({ ...prev, dashboard: true }));
      const token = localStorage.getItem("token");

      if (!token) return applyStaticData();

      const response = await axios.get(
        "https://backend-srtt.onrender.com/api/crypto/dashboard",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (!response.data.success) return applyStaticData();

      const assets = response.data.data.assets || [];

      const mappedAssets = assets.map(asset => ({
        icon: getCryptoIcon(asset.symbol),
        name: getDisplayName(asset.symbol),
        symbol: asset.symbol.toLowerCase(),
        sub: asset.name,
        price: formatCurrency(asset.currentPrice),
        rawChange: asset.priceChangePercentage24h,
        change: formatPercentage(asset.priceChangePercentage24h),
        balanceText: formatCurrency(asset.balance * asset.currentPrice),
        usdValue: asset.balanceValue,
        originalAsset: asset
      }));

      setUserAssets(mappedAssets);

      const totalUsd = assets.reduce(
        (sum, a) => sum + (a.balanceValue || 0),
        0
      );

      setTotalBalance(formatCurrency(totalUsd));
      setLastUpdate(new Date().toLocaleTimeString());
      setDataSource("live");

    } catch (err) {
      applyStaticData();
    } finally {
      setLoading(prev => ({ ...prev, dashboard: false }));
    }
  };

  // Use static data
  const applyStaticData = () => {
    setDataSource("static");
    setLastUpdate(new Date().toLocaleTimeString());

    const assetsWithIcons = STATIC_ASSETS.map(asset => ({
      ...asset,
      icon: getCryptoIcon(asset.symbol),
      price: formatCurrency(asset.price),
      balanceValue: asset.balanceValue,
      change: formatPercentage(asset.change)
    }));

    setUserAssets(assetsWithIcons);

    const total = STATIC_ASSETS.reduce(
      (sum, asset) => sum + asset.balanceValue,
      0
    );

    setTotalBalance(formatCurrency(total));
  };

  // Fetch Live Ticker Data
  const fetchTickerData = async () => {
    try {
      setLoading(prev => ({ ...prev, ticker: true }));
      const token = localStorage.getItem("token");

      if (!token) {
        const staticTicker = STATIC_ASSETS.map(asset => ({
          symbol: asset.name,
          name: asset.sub,
          price: asset.price,
          change: 0,
          changePercent: asset.change,
          volume: 0,
          marketCap: 0
        }));
        setTickerData(staticTicker);
        return;
      }

      const response = await axios.get("https://backend-srtt.onrender.com/api/crypto/ticker", {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        timeout: 8000
      });

      if (response.data.success && response.data.data) {
        setTickerData(response.data.data);
        localStorage.setItem('cryptoPrices', JSON.stringify(response.data.data));
      } else {
        const staticTicker = STATIC_ASSETS.map(asset => ({
          symbol: asset.name,
          name: asset.sub,
          price: asset.price,
          change: 0,
          changePercent: asset.change,
          volume: 0,
          marketCap: 0
        }));
        setTickerData(staticTicker);
      }
    } catch (error) {
      console.log("Error fetching ticker, using static data:", error.message);
      const staticTicker = STATIC_ASSETS.map(asset => ({
        symbol: asset.name,
        name: asset.sub,
        price: asset.price,
        change: 0,
        changePercent: asset.change,
        volume: 0,
        marketCap: 0
      }));
      setTickerData(staticTicker);
    } finally {
      setLoading(prev => ({ ...prev, ticker: false }));
    }
  };

  // Fetch Wallet Balance
  const fetchWalletBalance = async () => {
    try {
      setLoading(prev => ({ ...prev, balance: true }));
      const token = localStorage.getItem("token");

      if (!token) return;

      const response = await axios.get("https://backend-srtt.onrender.com/api/transfer/balance", {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.data.success) {
        setWalletBalance(response.data.data);
        localStorage.setItem('walletBalance', JSON.stringify(response.data.data));
      }
    } catch (error) {
      console.log("Error fetching wallet balance:", error.message);
    } finally {
      setLoading(prev => ({ ...prev, balance: false }));
    }
  };

  // Load saved data on component mount
  useEffect(() => {
    // Load saved profile
    const savedProfile = localStorage.getItem("userProfile");
    if (savedProfile) {
      setUserProfile(JSON.parse(savedProfile));
    }
  }, []);

  // Refresh all data
  const refreshAllData = () => {
    fetchDashboardData();
    fetchTickerData();
    fetchWalletBalance();
  };

  // Initial data fetch
  useEffect(() => {
    refreshAllData();
    fetchDebitCard();
    fetchUserProfile();

    const intervalId = setInterval(() => {
      fetchDashboardData();
      fetchTickerData();
    }, 60000);

    return () => clearInterval(intervalId);
  }, [userEmail]);

  const openWallet = (asset) => {
    const assetToPass = {
      ...asset,
      iconPath: asset.icon,
      originalAsset: asset.originalAsset || {
        key: asset.symbol.toLowerCase(),
        balance: asset.originalAsset?.balance || 0,
        balanceValue: asset.originalAsset?.balanceValue || asset.usdValue || 0,
        currentPrice: asset.originalAsset?.currentPrice || 
                     (typeof asset.price === 'string' 
                       ? parseFloat(asset.price.replace(/[^0-9.-]+/g, "")) 
                       : asset.price),
        symbol: asset.symbol,
        name: asset.sub
      }
    };

    console.log('🔍 Opening wallet with asset:', assetToPass.originalAsset);
    navigate("/bitcoinwallet", {
      state: assetToPass
    });
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const handleSend = () => {
    if (userAssets && userAssets.length > 0) {
      navigate("/sendbtc", {
        state: {
          ...userAssets[0],
          name: userAssets[0].name,
          sub: userAssets[0].sub,
          balance: userAssets[0].balance,
          icon: userAssets[0].icon
        }
      });
    } else {
      navigate("/sendbtc");
    }
  };

  const handleReceive = () => {
    navigate("/balreceive");
  };

  const handleBuy = () => {
    navigate("/walletoption");
  };

  const handleHistory = () => {
    navigate("/history");
  };

  const displayAssets = userAssets.length > 0 ? userAssets : STATIC_ASSETS.map(asset => ({
    ...asset,
    price: formatCurrency(asset.price),
    balanceValue: formatCurrency(asset.balanceValue),
    change: formatPercentage(asset.change)
  }));

  // ✅ Get card status from either current cardData or localStorage
  const getCardStatus = () => {
    if (cardData?.status) {
      return cardData.status;
    }
    const savedCard = localStorage.getItem("userCardData");
    if (savedCard) {
      return JSON.parse(savedCard).status;
    }
    return "INACTIVE";
  };

  return (
    <>
      <div className={`dashboard ${sidebarOpen ? 'blur-background' : ''}`}>
        <header className="header">
          <img src={logo} alt="logo" />
          <div className="menu" onClick={toggleSidebar}>☰</div>
        </header>

        <div className="top-section">
          <div className="balance-card">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span className="connect">
                <Link className="Connect-link" to="/walletoption">Connect Wallet</Link>
              </span>
            </div>
            <p>Your Balance</p>
            <h2>{totalBalance}</h2>

            <div style={{
              fontSize: '11px',
              color: '#888',
              marginBottom: '15px',
              display: 'flex',
              justifyContent: 'space-between'
            }}>
              <span>Last updated: {lastUpdate || '--:--'}</span>
            </div>

            <div className="actions">
              <div onClick={handleReceive}>
                <div className="action-box">
                  <img src={receivearrow} alt="Receive" style={{ width: '48px', height: '40px' }} />
                </div>
                <span>Receive</span>
              </div>
              <div onClick={handleSend}>
                <div className="action-box">
                  <img src={sendarrow} alt="Send" style={{ width: '48px', height: '48px' }} />
                </div>
                <span>Send</span>
              </div>
              <div onClick={handleBuy}>
                <div className="action-box">
                  <img src={buyarrow} alt="Buy" style={{ width: '48px', height: '48px' }} />
                </div>
                <span>Buy</span>
              </div>
              <div onClick={handleHistory}>
                <div className="action-box">
                  <img src={historyarrow} alt="History" style={{ width: '48px', height: '48px' }} />
                </div>
                <span>History</span>
              </div>
            </div>
          </div>

          <div className="visa-container">
            <Card
              type={mapCardType(cardData?.cardType)}
              number={cardData?.cardNumber || "XXXX XXXX XXXX XXXX"}
              holder={
                cardData?.fullName ||
                userProfile?.fullName ||
                "CARD HOLDER"
              }
              expiry={cardData?.expiry || "XX/XX"}
              cvv={cardData?.cvv || "XXX"}
              // ✅ FIX: Use getCardStatus to preserve status across transactions
              status={getCardStatus()}
            />
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
          <h3 className="assets-title">Assets</h3>
          {loading.dashboard && (
            <small style={{ color: '#ff9800', fontSize: '11px' }}>
              Loading...
            </small>
          )}
        </div>

        <div className="assets">
          {displayAssets.map((item, i) => (
            <div
              className="asset-card"
              key={i}
              onClick={() => openWallet(item)}
              style={{ cursor: "pointer" }}
            >
              <img src={item.icon} alt={item.name} />
              <div className="asset-info">
                <strong>{item.name}</strong>
                <span>{item.sub}</span>
              </div>
              <div className="asset-price">
                <strong>{item.price}</strong>
                <span className={item.rawChange >= 0 ? "green" : "red"}>
                  {item.change} 24hr
                </span>
              </div>
              <div className="asset-balance">
                {item.balanceText}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div
        className={`sidebar-overlay ${sidebarOpen ? "active" : ""}`}
        onClick={closeSidebar}
      ></div>

      <div className={`sidebar ${sidebarOpen ? "active" : ""}`}>
        <div className="sidebar-header">
          <img src={logo} alt="logo" className="sidebar-logo" />

          <Link
            to="/userprofile"
            className="user-profile-btn"
            onClick={closeSidebar}
          >
            User Profile
          </Link>

          <button className="close-sidebar" onClick={closeSidebar}>
            ×
          </button>
        </div>

        <div className="sidebar-menu">
          {isAdmin && (
            <div className="sidebar-item">
              <Link to="/admin-panel" onClick={closeSidebar}>
                Admin Panel
              </Link>
            </div>
          )}

          <div className="sidebar-item">
            <Link to="/dashboard" onClick={closeSidebar}>Dashboard</Link>
          </div>

          <div className="sidebar-item">
            <Link to="/withdrawal" onClick={closeSidebar}>Withdrawal</Link>
          </div>

          <div className="sidebar-item">
            <Link to="/creditcards" onClick={closeSidebar}>Activate Debit Card</Link>
          </div>

          <div className="sidebar-item">
            <Link to="/walletoption" onClick={closeSidebar}>
              Connect Trust Wallet
            </Link>
          </div>

          <div className="sidebar-item">
            <Link to="/support" onClick={closeSidebar}>Support</Link>
          </div>

          <div className="sidebar-item">
            <Link to="/report" onClick={closeSidebar}>Report</Link>
          </div>

          <div className="sidebar-item">
            <Link to="/referearn" onClick={closeSidebar}>Referral Link</Link>
          </div>

          <div className="sidebar-item">
            <Link to="/spinwheel" onClick={closeSidebar}>Spin Wheel</Link>
          </div>

          <div className="sidebar-item">
            <Link
              to="/"
              onClick={() => {
                localStorage.clear();
                closeSidebar();
              }}
            >
              Logout
            </Link>
          </div>
        </div>
      </div>

      {/* Spin Wheel Navigation Button - On Right Side ABOVE WhatsApp */}
      <SpinWheelNavButton 
        position="right"
        bottom="100px"
        right="30px"
        pulseEffect={true}
        size="60px"
      />

      {/* WhatsApp Float Button - On Right Side BELOW Spin Wheel */}
      <WhatsAppFloat 
        phoneNumber="15485825756"
        message="Hello! I need assistance with my InstaCoinXPay dashboard."
        position="right"
        bottom="30px"
        right="30px"
        pulseEffect={true}
      />
    </>
  );
};

export default Dashboard;